module.exports = __webpack_public_path__ + "dab3048f6a395422e9842c0335fe3e89.svg";